module.exports = __webpack_public_path__ + "img/header-memoireRingsRingsets.a92e199.jpg";